module.exports = __webpack_public_path__ + "static/media/emotional-intro.ef4c8c40.svg";